import Ajax from "Utils/ajax";
export const getAllStaffByHRorManager = (data) => Ajax.post('hr/getAllStaffByHRorManager',data);
export const leaveReason = () => Ajax.post('hr/leaveReason'); 
export const addSLException = (data) => Ajax.post('hr/addSLException',data); 
export const shortLeaveExceptionList = (data) => Ajax.post('hr/shortLeaveExceptionList',data); 
export const getSlExceptionById = (data) => Ajax.post('hr/getSlExceptionById',data); 